import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

export const userPreferenceApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getUserPreferences",
    method: "get",
    path: "/org_permissions/",
    status: 200,
    response: z.object({
      product_identifier: z.literal("asin").or(z.literal("sku")),
      preferences: z.object({
        acos_or_roas: z.literal("acos").or(z.literal("roas")),
      }),
    }),
  })
    .addEndpoint({
      alias: "putUserPreferences",
      method: "put",
      path: "/org_permissions/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            product_identifier: z.literal("asin").or(z.literal("sku")),
            acos_or_roas: z.literal("acos").or(z.literal("roas")),
          }),
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "patchUserProfilePreferences",
      method: "patch",
      path: "/user_preferences/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            language: z.string(),
          }),
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "patchUserOrgName",
      method: "patch",
      path: "/update_org_name/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            org_name: z.string(),
          }),
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "createModule",
      method: "post",
      path: "/module/controller/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            module_name: z.string(),
          }),
        },
      ],
      status: 200,
      response: z.array(
        z.object({
          module_name: z.string(),
          id: z.number(),
        }),
      ),
    })
    .addEndpoint({
      alias: "bulkUpdateModules",
      method: "post",
      path: "/module/controller/bulk-update/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            org_ids: z.array(z.number()),
            modules: z.array(z.object({ module_name: z.string(), enabled: z.boolean() })),
          }),
        },
      ],
      status: 200,
      response: z.object({
        modules: z.array(z.object({ module_name: z.string(), enabled: z.boolean() })),
        updated_orgs: z.array(z.number()),
      }),
    })
    .addEndpoint({
      alias: "deleteModule",
      method: "delete",
      path: "/module/controller/:module_name/",
      status: 204,
      response: z.unknown(),
    })
    .build(),
);
